export enum sweetAlert {
    DARK_BACKGROUND = '#1a202e',
    WHITE_BACKGROUND = 'white',
    DARK_COLOR = 'white',
    WHITE_COLOR = 'black',
}
